<template>
  <div class="container-fluid">
    <page-header :page="page">
      <template v-slot:customActions>
        <div class="d-flex justify-content-end h-100 align-items-end">
          <ActionButton
            :class="['mr-1', { 'w-50': isMobile, 'mb-3': !isMobile }]"
            text="Imprimir"
            variant="success"
            i="fas fa-print"
            @click="onPrintReport(true, filters.academicYear.id)"
          />
          <ActionButton
            :class="[{ 'w-50 mr-1': isMobile, 'mb-3': !isMobile }]"
            v-if="showAddIrregularPeopleButton"
            text="Añadir"
            variant="success"
            i="fas fa-file-plus"
            @click="goAddRequestPersonalStaff"
          />
        </div>
      </template>
    </page-header>
    <filter-manager
      v-model="filters"
      :filters="filtersHeader"
      @academicYear="
        updateFiltersData('academicYear', $event, 'onAcademicYearChanged')
      "
      @region="updateFiltersData('region', $event, 'onRegionChanged')"
      @center="updateFiltersData('center', $event, 'onCenterChanged')"
      @municipality="
        updateFiltersData('municipality', $event, 'onMunicipalityChanged')
      "
      @search="onSearch"
    />

    <custom-separator
      text="Resultado de Solicitud"
      class="my-4 custom-separator-line"
    />

    <CustomResultNotFound
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No se ha encontrado resultado de solicitud para este periodo."
    />

    <div v-if="!showNotResults" class="search-result">
      <SearchResultRow
        v-for="item in collections.searchResult"
        :key="`row-item-${item.id}`"
        ref="resultRow"
        :value="item"
        @changeStatus="changeRequestStatus"
        @delete="onDeleteHandler"
        @printRequest="onPrintReport(false, $event)"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.perPage"
        :data="pagination"
        @pagination-go-page="onPageChanged"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import FilterManager from 'FilterManager';
import {
  getRequestStatusList,
  getRequests,
  updateRequestStatus,
  getRequestReport,
  deleteRequest,
} from '@/modules/human-resources/api';
import locationService from '@/services/api/location.api.js';
import academicService from '@/services/api/academicUtils.api.js';
import EduEspCode from '@/utils/constants/eduEspCode';
import SearchResultRow from './components/SearchResultRow';
import CustomResultNotFound from 'custom-result-not-found';
import CustomSeparator from 'custom-separator';
import Pagination from 'pagination';
import storeMixin from '@/mixin/storeGenerator';
import generalService from '@/services/pei/general';
import alert from '@/mixin/alert.mixin';

import { getSysparameterByNames } from "@/modules/system-parameter-managment/api";
import store from "@/store/index";

export default {
  name: 'HumanResources',
  mixins: [storeMixin, alert],
  components: {
    PageHeader,
    ActionButton,
    FilterManager,
    SearchResultRow,
    CustomResultNotFound,
    CustomSeparator,
    Pagination,
  },
  data() {
    return {
      collections: {
        academicYears: [],
        status: [],
        centers: [],
        regions: [],
        municipalities: [],
        schools: [],
        assistantTypes: [],
        searchResult: [],
      },
      filters: {
        academicYear: null,
        status: null,
        searchField: null,
        center: null,
        region: null,
        municipality: null,
        school: null,
        assistantType: null,
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
      regionDisabled: false,
      centerDisabled: false,
      municipalityDisabled: false,
      schoolDisabled: false,
      showAddIrregularPeopleButton: false,
    };
  },
  methods: {
    async onSearch(filters, page = 1) {
      const mappedFilter = {
        academicYearId: (filters.academicYear || {}).id,
        statusId: (filters.status || {}).id,
        searchField: filters.searchField,
        centerId: (filters.center || {}).id,
        municipalityId: (filters.municipality || {}).id,
        regionId: (filters.region || {}).id,
        schoolId: (filters.school || {}).id,
        assistantTypeId: (filters.assistantType || {}).id,
        pageIndex: page,
      };

      await getRequests(mappedFilter).then((res) => {
        this.collections.searchResult = res.data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };
      });
    },
    async onPageChanged(currentPage) {
      this.collapseAll();
      this.pagination.currentPage = currentPage;
      await this.onSearch(this.filters, currentPage);
    },
    collapseAll() {
      this.collections.searchResult.forEach((item, index) => {
        this.$refs.resultRow[index].close();
      });
    },
    goAddRequestPersonalStaff() {
      this.$router.push('/humanres/request/add');
    },
    updateFiltersData(key, event, callback) {
      if (event != undefined && event != null && event != '') {
        this.filters[key] = event;
      } else {
        this.filters[key] = null;
      }

      if (callback != undefined) {
        if (typeof this[callback] == 'function') {
          this[callback](event);
        }
      }
    },
    async onAcademicYearChanged(academicYear) {
      this.filters.region = null;
      this.filters.center = null;
      this.filters.municipality = null;
      this.filters.school = null;
      this.filters.status = null;

      this.collections.centers = [];
      this.collections.municipalities = [];
      this.collections.schools = [];
      this.collections.status = [];

      const { data: statusList } = await getRequestStatusList(this.filters.academicYear.id);

      this.collections.status = statusList;      
      
      await this.fetchRegions(academicYear.id);
    },
    async onRegionChanged(region) {
      this.filters.center = null;
      this.filters.municipality = null;
      this.filters.school = null;
      this.collections.centers = [];
      this.collections.municipalities = [];
      this.collections.schools = [];
      if (region) {
        await this.fetchCenters(region.id);
      }
    },
    async onCenterChanged(center) {
      this.filters.municipality = null;
      this.filters.school = null;
      this.collections.municipalities = [];
      this.collections.schools = [];
      if (center) {
        await this.fetchMunicipalities(center.id);
      }
    },
    async onMunicipalityChanged(municipality) {
      this.filters.school = null;
      this.collections.schools = [];
      if (municipality) {
        await this.fetchSchools(municipality.id);
      }
    },
    async fetchRegions(academicYearId) {
      const { data } = await locationService.getRegions({ academicYearId });
      this.collections.regions = data;

      if (data != null && data.length == 1 && data[0].selected) {
        this.filters.region = data[0];
        this.regionDisabled = true;

        await this.fetchCenters(data[0]);
      } else {
        this.regionDisabled = false;
      }
    },
    async fetchCenters(regionId) {
      const { data } = await locationService.getCenters({
        regionId,
        academicYearId: this.filters.academicYear.id,
      });
      this.collections.centers = data;

      if (data != null && data.length == 1 && data[0].selected) {
        this.filters.center = data[0];
        this.centerDisabled = true;

        await this.fetchMunicipalities(data[0]);
      } else {
        this.centerDisabled = false;
      }
    },
    async fetchMunicipalities(centerId) {
      const { data } = await locationService.getMunicipalities({
        centerId,
        academicYearId: this.filters.academicYear.id,
      });
      this.collections.municipalities = data;

      if (data != null && data.length == 1 && data[0].selected) {
        this.filters.municipality = data[0];
        this.municipalityDisabled = true;

        await this.fetchSchools(data[0]);
      } else {
        this.municipalityDisabled = false;
      }
    },
    async fetchSchools(municipalityId) {
      const { data } = await locationService.getSchools({
        municipalityId,
        academicYearId: this.filters.academicYear.id,
      });
      this.collections.schools = data;

      if (data != null && data.length == 1 && data[0].selected) {
        this.filters.school = data[0];
        this.schoolDisabled = true;
      } else {
        this.schoolDisabled = false;
      }
    },
    async fetchQuickFiltersData() {
      const academicYears = await academicService.getHRrequestAcademicYears();      

      this.collections.academicYears = academicYears.map((academicYear) => ({
        ...academicYear,
        name: academicYear.description,
      }));

      if (
        this.collections.academicYears != null &&
        this.collections.academicYears.some((e) => e.selected)
      ) {
        this.filters.academicYear = this.collections.academicYears.find(
          (e) => e.selected
        );
      } else if (
        this.collections.academicYears != null &&
        this.collections.academicYears.length == 1
      ) {
        this.filters.academicYear = this.collections.academicYears[0];
      }

      const { data: statusList } = await getRequestStatusList(this.filters.academicYear.id);

      this.collections.status = statusList;
    },
    async fetchAsistanType() {
      const { data } = await academicService.getEduEsp({
        codetype: EduEspCode.AsistantType,
      });
      this.collections.assistantTypes = data;
    },
    async fetchResources() {
      await this.fetchQuickFiltersData();
      await this.fetchRegions(this.filters.academicYear.id);
      await this.fetchAsistanType();
    },
    async changeRequestStatus(requestId, dto) {
      await updateRequestStatus(requestId, dto)
            .then(() => {
              this.ShowToast(
                "Confirmación",
                "La solicitud ha sido cambiada de estatus exitosamente.",
                "success"
              );
            })
            .catch((error) => {
              this.ShowToast(
                "Información Incompleta",
                error.response.data.message,
                "error"
              );
            });
        
      await this.onSearch(this.filters, this.pagination.currentPage);
    },

    async onDeleteHandler(requestId) {
      await deleteRequest(requestId)
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'La solicitud ha sido eliminada exitosamente.',
            'success'
          );
          this.onSearch(this.filters, this.pagination.currentPage);
        })
        .catch((err) => {
          this.ShowToast('Alerta', err.response.data.message, 'error');
        });
    },
    async onPrintReport(isHistory, id) {
      let self = this;

      await getRequestReport(isHistory, id)
        .then((res) => {
          self.report = res;
          generalService.documentDownloadReport(
            self.report.content,
            self.report.filename,
            self.report.contentType
          );
        })
        .catch((err) => {
          alert(err);
        });
    },
    async setAddIrregularPeopleButton() {
      this.showAddIrregularPeopleButton = false;

      const hasPermission = store.getters.HasPermission("eduesp.hr.addirregularpeople");
      if (hasPermission) {
        this.showAddIrregularPeopleButton = true;
        return;
      }

      const academicYearId = this.currentAcademicYear().id;
      const { data: sysParameters } = await getSysparameterByNames({
        parameterNames: ["StartSchoolDate"],
        academicYearId
      });

      if (!sysParameters[0]?.staticValue) return;

      const dateToShow = new Date(sysParameters[0].staticValue);
      const currentDate = new Date();

      if (
        dateToShow.getUTCFullYear() != currentDate.getUTCFullYear() ||
        dateToShow.getUTCMonth() != currentDate.getUTCMonth() ||
        dateToShow.getUTCDate() != currentDate.getUTCDate()
      )
        return;

      this.showAddIrregularPeopleButton = true;
    },
  },
  computed: {
    page() {
      return {
        icon: 'fas fa-user-edit',
        title: 'Solicitud de Personal Irregular',
        routes: ['Inicio', 'Recursos Humanos', 'Personal Irregular'],
      };
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    filtersHeader() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.collections.academicYears,
          value: this.filters.academicYear,
          placeholder: 'Seleccione el año',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: false,
          class: 'col-sm-6 col-md-6 col-lg-3 ml-0 mr-0',
          classContainer: 'w-100',
          validations: 'required',
          mapParentValue: this.filters.academicYear == null,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.collections.status,
          value: this.filters.status,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-6 col-md-6 col-lg-3 ml-0 mr-0',
          classContainer: 'w-100',
          mapParentValue: this.filters.status == null,
        },
        {
          name: 'searchField',
          component: 'CustomInput',
          placeholder:
            'Escriba Número de SIE, Registro, Solicitud o Nombre del Estudiante',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-sm-12 col-md-6',
          type: 'text',
        },
        {
          name: 'region',
          label: 'Región:',
          component: 'CustomDropDown',
          options: this.collections.regions,
          value: this.filters.region,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-4 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filters.region == null,
          isAdvanced: true,
          disabled: this.regionDisabled,
        },
        {
          name: 'center',
          label: 'Centro:',
          component: 'CustomDropDown',
          options: this.collections.centers,
          value: this.filters.center,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-4 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filters.center == null,
          isAdvanced: true,
          disabled: this.centerDisabled,
        },
        {
          name: 'municipality',
          label: 'Municipio:',
          component: 'CustomDropDown',
          options: this.collections.municipalities,
          value: this.filters.municipality,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-4 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filters.municipality == null,
          isAdvanced: true,
          disabled: this.municipalityDisabled,
        },
        {
          name: 'school',
          label: 'Escuela:',
          component: 'CustomDropDown',
          options: this.collections.schools,
          value: this.filters.school,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-4 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filters.school == null,
          isAdvanced: true,
          disabled: this.schoolDisabled,
        },
        {
          name: 'assistantType',
          label: 'Tipo de Solicitud:',
          component: 'CustomDropDown',
          options: this.collections.assistantTypes,
          value: this.filters.assistantType,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-4 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filters.assistantType == null,
          isAdvanced: true,
        },
      ];
    },
    showNotResults() {
      return this.collections.searchResult.length == 0;
    },
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const persistRoutes = [
      'AddRequestPersonalStaff',
      'EditRequestPersonalStaff',
    ];

    next(async (vm) => {
      if (persistRoutes.some((x) => x == from.name)) {
        vm.recoveryData();
      } else {
        vm.shouldRecovery = false;
        vm.showAdvanced = false;
        await vm.fetchResources();
      }
      await vm.onSearch(vm.filters, vm.pagination.currentPage);
    });
  },
  mounted() {
    this.setAddIrregularPeopleButton();
  },
};
</script>

<style></style>
